/**
 * Feature flags pour activer/désactiver des fonctionnalités par organisation
 */

import { IS_DEVELOPMENT } from './environment';

/**
 * Liste des organisations autorisées pour la fonctionnalité SAV Chat en production
 */
const SAV_CHAT_ALLOWED_ORGS_PRODUCTION: string[] = [];

/**
 * Liste des organisations autorisées pour la fonctionnalité Live Assistant IA en production
 */
const LIVE_ASSISTANT_ALLOWED_ORGS_PRODUCTION: string[] = [];

/**
 * Liste des organisations autorisées pour la configuration des clés API Stripe en production
 */
const STRIPE_API_KEY_ALLOWED_ORGS_PRODUCTION = ['glowlive'];
/** Sendcloud plateforme (compte CashLive) autorisé seulement pour ces orgas. */
const SENDCLOUD_PLATFORM_ALLOWED_ORGS_PRODUCTION = ['glowlive', 'dresslive'];

/**
 * Vérifie si la fonctionnalité SAV Chat est disponible pour une organisation
 * Activé pour toutes les organisations
 */
export function isSavChatEnabled(_organizationId?: string | null | undefined, _config?: any): boolean {
  // Activé pour tous
  return true;
}

/**
 * Vérifie si la fonctionnalité Live Assistant IA est disponible pour une organisation
 * Activé pour toutes les organisations
 */
export function isLiveAssistantEnabled(_organizationId?: string | null | undefined, _config?: any): boolean {
  // Activé pour tous
  return true;
}

/**
 * Vérifie si la configuration des clés API Stripe est disponible pour une organisation
 */
export function isStripeApiKeyConfigEnabled(organizationId: string | null | undefined, config?: any): boolean {
  if (IS_DEVELOPMENT) return true;
  if (!organizationId) return false;

  // Priorité : Abonnement PRO actif
  if (config?.subscriptionConfig?.planType === 'PRO') return true;

  // Fallback : Liste statique de production (organisations autorisées)
  return STRIPE_API_KEY_ALLOWED_ORGS_PRODUCTION.includes(organizationId.toLowerCase());
}

/**
 * Vérifie si le provider Sendcloud plateforme est disponible pour une organisation.
 * Objectif métier : conserver uniquement Sendcloud API key + Mondial Relay pour les autres orgas.
 */
export function isSendcloudPlatformProviderEnabled(
  organizationId: string | null | undefined,
): boolean {
  if (!organizationId) return false;
  return SENDCLOUD_PLATFORM_ALLOWED_ORGS_PRODUCTION.includes(organizationId.toLowerCase());
}

/**
 * Liste des fonctionnalités et leurs organisations autorisées
 */
export const FEATURE_FLAGS = {
  SAV_CHAT: {
    enabled: (orgId: string | null | undefined) => isSavChatEnabled(orgId),
    allowedOrgs: SAV_CHAT_ALLOWED_ORGS_PRODUCTION,
  },
  LIVE_ASSISTANT: {
    enabled: (orgId: string | null | undefined) => isLiveAssistantEnabled(orgId),
    allowedOrgs: LIVE_ASSISTANT_ALLOWED_ORGS_PRODUCTION,
  },
  STRIPE_API_KEY_CONFIG: {
    enabled: (orgId: string | null | undefined) => isStripeApiKeyConfigEnabled(orgId),
    allowedOrgs: STRIPE_API_KEY_ALLOWED_ORGS_PRODUCTION,
  },
  SENDCLOUD_PLATFORM_PROVIDER: {
    enabled: (orgId: string | null | undefined) => isSendcloudPlatformProviderEnabled(orgId),
    allowedOrgs: SENDCLOUD_PLATFORM_ALLOWED_ORGS_PRODUCTION,
  },
} as const;

